import { http } from '../common/http-client'
import { joinPath } from '../common/url-util'
import { DEFAULT_CONTEXT_PATH } from '../common/constants'
import { redirectToLocation } from '../common/redirect'

/**
 * Triggers a 'complete' logout, which invalidates the ATAPI and the OAuth session.
 * Finally it (optionally) triggers the authorization flow by navigating to the ATAPI config URL.
 *
 * @param {string} contextPath - The home path of the ATAPI logout route (e.g. /api)
 * @param {boolean} [immediateRedirect=true] - Request config to trigger a redirect to Authserver's login page
 * Defaults to reload current browser location
 */
export function doLogout(contextPath = DEFAULT_CONTEXT_PATH, immediateRedirect = true) {
    return async () => {
        const url = joinPath(contextPath, 'logout?returnOAuthLogoutUrl')
        const res = await http.post(url, null, { credentials: 'include' })
        const oAuthLogoutUrl = res && res.data && res.data.oAuthLogoutUrl
        if (!oAuthLogoutUrl) {
            return
        }
        if (immediateRedirect) {
            redirectToLocation(oAuthLogoutUrl, 'sameWindow')
        }
    }
}
